import React from 'react';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { ButtonPropsType } from 'src/ui/components/button/common/types';
import { Button } from 'src/ui/components/button/common/Button';

export const ViewAllButton = ({ children, onClick }: Partial<ButtonPropsType>) => {
    return (
        <Button
            size='small'
            appearance='primary'
            variant={DefaultComponentVariantType.TERTIARY}
            onClick={onClick}
        >
            {children ? (
                children
            ) : (
                <I18n
                    langKey='section-header.view-all'
                    defaultText='View All'
                />
            )}
        </Button>
    );
};
